<app-menu currentMenu="main"></app-menu>
<div class="page page-error">
    <div class="error-container" *ngIf="errorDetails">
        <img src="assets/ic_error.svg">
        <h1>{{errorDetails.title}}</h1>
    </div>
</div>
<app-footer></app-footer>